/* eslint-disable max-lines-per-function, no-empty-function */
import { useMutation } from "@apollo/client";
import { mutations } from "@bluframe/mightychroma-mightytool-graphql-schema";
import { useCallback, useMemo } from "react";
import createNewsCritics from "./createNewsCritics";
const { news: { ADD_NEWS_SOURCE } } = mutations;
export const initialContext = {
    areNewsSourcesCalled: false,
    areNewsSourcesLoading: false,
    avNirvanaData: undefined,
    bluRayData: undefined,
    hidefDigestData: undefined,
    onCreateNewsSource: () => { },
    resetNewsSources: () => { },
    singleSourceData: undefined,
    whySoBluData: undefined
};
const useCreateNewsCriticsContext = ({ avNirvana, bluRay, hidefDigest, news, singleSource, whySoBlu }) => {
    const [addAvNirvana, { called: avNirvanaCalled, data: avNirvanaData, loading: avNirvanaLoading, reset: avNirvanaReset }] = useMutation(ADD_NEWS_SOURCE, {
        variables: {
            newsSourceAddInput: {
                overrides: avNirvana.selected.overrides,
                serviceName: "avNirvana",
                url: avNirvana.selected.url
            }
        }
    });
    const [addBluRay, { called: bluRayCalled, data: bluRayData, loading: bluRayLoading, reset: bluRayReset }] = useMutation(ADD_NEWS_SOURCE, {
        variables: {
            newsSourceAddInput: {
                overrides: bluRay.selected.overrides,
                serviceName: "bluRay",
                url: bluRay.selected.url
            }
        }
    });
    const [addHidefDigest, { called: hidefDigestCalled, data: hidefDigestData, loading: hidefDigestLoading, reset: hidefDigestReset }] = useMutation(ADD_NEWS_SOURCE, {
        variables: {
            newsSourceAddInput: {
                overrides: hidefDigest.selected.overrides,
                serviceName: "hidefDigest",
                url: hidefDigest.selected.url
            }
        }
    });
    const [addWhySoBlu, { called: whySoBluCalled, data: whySoBluData, loading: whySoBluLoading, reset: whySoBluReset }] = useMutation(ADD_NEWS_SOURCE, {
        variables: {
            newsSourceAddInput: {
                overrides: whySoBlu.selected.overrides,
                serviceName: "whySoBlu",
                url: whySoBlu.selected.url
            }
        }
    });
    const [addSingleSource, { called: singleSourceCalled, data: singleSourceData, loading: singleSourceLoading, reset: singleSourceReset }] = useMutation(ADD_NEWS_SOURCE, {
        variables: {
            newsSourceAddInput: {
                labelId: singleSource.labelId,
                outletId: singleSource.outletId,
                releaseDate: news.releaseDate ?? undefined,
                /**
                 * TODO: We really need to find a way for this to only do it when url is defined
                 */
                url: singleSource.url ?? ""
            }
        }
    });
    const areNewsSourcesCalled = useMemo(() => avNirvanaCalled ||
        bluRayCalled ||
        hidefDigestCalled ||
        singleSourceCalled ||
        whySoBluCalled, [
        avNirvanaCalled,
        bluRayCalled,
        hidefDigestCalled,
        singleSourceCalled,
        whySoBluCalled
    ]);
    const areNewsSourcesLoading = useMemo(() => avNirvanaLoading ||
        bluRayLoading ||
        hidefDigestLoading ||
        singleSourceLoading ||
        whySoBluLoading, [
        avNirvanaLoading,
        bluRayLoading,
        hidefDigestLoading,
        singleSourceLoading,
        whySoBluLoading
    ]);
    const resetNewsSources = useCallback(() => {
        if (avNirvanaData) {
            avNirvanaReset();
        }
        if (bluRayData) {
            bluRayReset();
        }
        if (hidefDigestData) {
            hidefDigestReset();
        }
        if (singleSourceData) {
            singleSourceReset();
        }
        if (whySoBluData) {
            whySoBluReset();
        }
    }, [
        avNirvanaData,
        avNirvanaReset,
        bluRayData,
        bluRayReset,
        hidefDigestData,
        hidefDigestReset,
        singleSourceData,
        singleSourceReset,
        whySoBluData,
        whySoBluReset
    ]);
    const onCreateNewsSource = useCallback(() => {
        createNewsCritics({
            addAvNirvana,
            addBluRay,
            addHidefDigest,
            addSingleSource,
            addWhySoBlu,
            avNirvanaReady: Boolean(avNirvana.selected.url) &&
                !news.sourcesIds?.includes(avNirvana.selected.id),
            bluRayReady: Boolean(bluRay.selected.url) &&
                !news.sourcesIds?.includes(bluRay.selected.id),
            hidefDigestReady: Boolean(hidefDigest.selected.url) &&
                !news.sourcesIds?.includes(hidefDigest.selected.id),
            singleSourceReady: Boolean(singleSource.labelId || singleSource.outletId) &&
                Boolean(singleSource.url),
            whySoBluReady: Boolean(whySoBlu.selected.url) &&
                !news.sourcesIds?.includes(whySoBlu.selected.id)
        });
    }, [
        addAvNirvana,
        addBluRay,
        addHidefDigest,
        addSingleSource,
        addWhySoBlu,
        avNirvana.selected.id,
        avNirvana.selected.url,
        bluRay.selected.id,
        bluRay.selected.url,
        hidefDigest.selected.id,
        hidefDigest.selected.url,
        news.sourcesIds,
        singleSource.labelId,
        singleSource.outletId,
        singleSource.url,
        whySoBlu.selected.id,
        whySoBlu.selected.url
    ]);
    return useMemo(() => ({
        areNewsSourcesCalled,
        areNewsSourcesLoading,
        avNirvanaData,
        bluRayData,
        hidefDigestData,
        onCreateNewsSource,
        resetNewsSources,
        singleSourceData,
        whySoBluData
    }), [
        areNewsSourcesCalled,
        areNewsSourcesLoading,
        avNirvanaData,
        bluRayData,
        hidefDigestData,
        onCreateNewsSource,
        resetNewsSources,
        singleSourceData,
        whySoBluData
    ]);
};
export default useCreateNewsCriticsContext;
